import { Button } from 'component/Button'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { controller } from 'store/controller'
import { opt } from 'store/opt'
import { store } from 'store/store'

export const TakeButton = observer(() => {
  const { camera } = store.profile.common
  const { canTake } = camera
  const stand = opt.stand

  const onTake = useLatestCallback(async () => {
    if (stand) await camera.countdown()
    await store.profile.common.take()
    controller.closeSelfieBanner()
  })

  return (
    <Button
      primary
      wide
      upper
      disabled={!canTake}
      action={onTake}
      large={opt.basic}
    >
      {i18n('TakePhoto')}
    </Button>
  )
})
